export default __webpack_public_path__ + "images/f1e9dd304b7273eac256d83d2546c121.svg";